// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Du","tooltip":"Eu","content":"Fu","simpleTooltip":"Gu","left":"Hu","right":"Iu","sponsored":"Ju"};